import {
    SET_MINDSETS
} from "@/views/mindset/store/types/types.js";

const mutations = {
    [SET_MINDSETS]: (state, payload) => state.listMindset = payload,
}

export default mutations;